<mat-card class="login-card" fxLayoutAlign="center center">
  <mat-card-content class="full-width">
    <div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <h5 fxFlex="50%" class="mt-0">Select an Advertiser</h5>
        <mat-form-field fxFlex="50%">
          <input matInput (keyup)="filter($event)" placeholder="Filter" />
        </mat-form-field>
      </div>

      <div class="advertiser-list-view">
        <div *ngFor="let adv of filtered" class="advertiser-row ma-1" fxLayout="row" fxLayoutAlign="center center">
          <div fxFlex="grow">{{ adv.name }}</div>
          <div fxFlex="noshrink">
            <button mat-raised-button (click)="pickAdvertiser(adv.id)">Select</button>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
